import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { errorHandler } from '@app/utils/errorHandler';
import { QuarterlyBonusResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
  quarter: number;
};

const getManagerQuarterlyBonus = async (params: Params): Promise<QuarterlyBonusResponse> => {
  const { data } = await api.get<QuarterlyBonusResponse>(
    `${BI_BASE_URL}/managers/bonus/quarterly/leaderboard`,
    { params }
  );

  return data;
};

export const useGetManagerQuarterlyBonus = ({
  year,
  quarter,
}: Params): UseQueryResult<QuarterlyBonusResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.QUARTERLY_BONUS, year, quarter],
    queryFn: () => getManagerQuarterlyBonus({ year, quarter }),
    ...errorHandler,
  });
};
